// Generated by purs version 0.15.15
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Ouroboros_Models_Brands_AdminUserRole from "../Ouroboros.Models.Brands.AdminUserRole/index.js";
import * as Ouroboros_Models_Brands_AdminUserStatus from "../Ouroboros.Models.Brands.AdminUserStatus/index.js";
import * as Ouroboros_Models_Brands_Email from "../Ouroboros.Models.Brands.Email/index.js";
import * as Ouroboros_Models_Brands_ErrorMessageText from "../Ouroboros.Models.Brands.ErrorMessageText/index.js";
import * as Ouroboros_Models_Brands_SeatCount from "../Ouroboros.Models.Brands.SeatCount/index.js";
import * as Ouroboros_Models_Brands_UUID from "../Ouroboros.Models.Brands.UUID/index.js";
import * as Ouroboros_Models_Core_Ok from "../Ouroboros.Models.Core.Ok/index.js";
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Services_Clients_Interop_IO from "../Ouroboros.Services.Clients.Interop.IO/index.js";
import * as Ouroboros_Services_Clients_Interop_Option from "../Ouroboros.Services.Clients.Interop.Option/index.js";
import * as Ouroboros_Services_Clients_Interop_Task from "../Ouroboros.Services.Clients.Interop.Task/index.js";
import * as Ouroboros_Services_Clients_Interop_TaskEither from "../Ouroboros.Services.Clients.Interop.TaskEither/index.js";
var eq2 = /* #__PURE__ */ Data_Eq.eq(Ouroboros_Models_Brands_AdminUserRole.eqAdminUserRole);
var toLoadingErrorInput = function (message) {
    return {
        message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText(message),
        info: Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)
    };
};
var runLoadingAction = function (v) {
    return v;
};
var readState = function (v) {
    return v;
};
var readOption = function (v) {
    return v;
};
var openEmailModal = function (kernel) {
    return function (user) {
        return Ouroboros_Services_Clients_Interop_IO.sequenceOk([ Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetSome(kernel.emailModalUser))(user), Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(kernel.emailModalValue))(Ouroboros_Models_Brands_Email.unwrap(user.email)), Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetMaybe(kernel.emailModalError))(Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)) ]);
    };
};
var onOpenEmailModal = function (kernel) {
    return openEmailModal(kernel);
};
var matchesEmail = function (email) {
    return function (user) {
        return Data_String_Common.toLower(Ouroboros_Models_Brands_Email.unwrap(user.email)) === Data_String_Common.toLower(email);
    };
};
var isSuperAdminFromRole = /* #__PURE__ */ Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
    return false;
})(function (role) {
    return Ouroboros_Models_Brands_AdminUserRole.unwrap(role) === "SuperAdmin";
});
var handleLoadSuccess = function (kernel) {
    return function (response) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Services_Clients_Interop_IO.sequenceOk([ Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetMaybe(kernel.loadError))(Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)), Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(kernel.users))(response.items), Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetSome(kernel.seatsUsed))(Ouroboros_Models_Brands_SeatCount.unwrap(response.seatsUsed)), Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetSome(kernel.seatLimit))(Ouroboros_Models_Brands_SeatCount.unwrap(response.seatLimit)), runLoadingAction(kernel.loading.setSuccess) ]));
    };
};
var handleActionSuccess = function (kernel) {
    return function (onSuccess) {
        return function (value) {
            return Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Services_Clients_Interop_IO.sequenceOk([ Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
                return Ouroboros_Services_Clients_Interop_IO.pure(Ouroboros_Models_Core_Ok.ok);
            })(function (handler) {
                return handler(value);
            })(onSuccess), runLoadingAction(kernel.loading.setSuccess) ]));
        };
    };
};
var handleAccountDetails = function (kernel) {
    return function (response) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetSome(kernel.currentEmail))(Ouroboros_Models_Brands_Email.unwrap(response.email)));
    };
};
var loadAccountDetailsTask = function (kernel) {
    return Ouroboros_Services_Clients_Interop_TaskEither.fold(function (v) {
        return Ouroboros_Services_Clients_Interop_Task.pure(Ouroboros_Models_Core_Ok.ok);
    })(handleAccountDetails(kernel))(kernel.accountClient.getAccountDetails);
};
var formatError = function (errorValue) {
    var $27 = errorValue.type === "Forbidden";
    if ($27) {
        return "You do not have permission to view or manage users.";
    };
    var $28 = errorValue.type === "Unauthorized";
    if ($28) {
        return "Please sign in again to continue.";
    };
    var message = Ouroboros_Models_Brands_ErrorMessageText.unwrap(errorValue.message);
    var $29 = message === "";
    if ($29) {
        return "Something went wrong.";
    };
    return message;
};
var handleActionError = function (kernel) {
    return function (errorValue) {
        var message = formatError(errorValue);
        return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(kernel.loading.setError(toLoadingErrorInput(message))));
    };
};
var taskWithError = function (kernel) {
    return function (taskEither) {
        return function (onSuccess) {
            return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
                return Ouroboros_Services_Clients_Interop_TaskEither.fold(handleActionError(kernel))(handleActionSuccess(kernel)(onSuccess))(taskEither);
            })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(kernel.loading.setLoading)));
        };
    };
};
var runTaskWithError = function (kernel) {
    return function (taskEither) {
        return function (onSuccess) {
            return Ouroboros_Programs_Capabilities.runTaskRunner(kernel.taskRunner)(taskWithError(kernel)(taskEither)(onSuccess));
        };
    };
};
var handleEmailModalError = function (kernel) {
    return function (errorValue) {
        var message = formatError(errorValue);
        return Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Services_Clients_Interop_IO.sequenceOk([ Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetSome(kernel.emailModalError))(message), Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(kernel.emailModalSubmitting))(false), runLoadingAction(kernel.loading.setError(toLoadingErrorInput(message))) ]));
    };
};
var handleLoadError = function (kernel) {
    return function (errorValue) {
        var message = formatError(errorValue);
        return Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Services_Clients_Interop_IO.sequenceOk([ Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetSome(kernel.loadError))(message), runLoadingAction(kernel.loading.setError(toLoadingErrorInput(message))) ]));
    };
};
var loadUsersTask = function (kernel) {
    return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
        return Ouroboros_Services_Clients_Interop_TaskEither.fold(handleLoadError(kernel))(handleLoadSuccess(kernel))(kernel.adminUserClient.listUsers);
    })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(kernel.loading.setLoading)));
};
var mountTask = function (kernel) {
    return Ouroboros_Services_Clients_Interop_Task.sequenceOk([ loadAccountDetailsTask(kernel), loadUsersTask(kernel) ]);
};
var refreshUsers = function (kernel) {
    return Ouroboros_Programs_Capabilities.runTaskRunner(kernel.taskRunner)(loadUsersTask(kernel));
};
var handleInviteSuccess = function (kernel) {
    return function (result) {
        return Ouroboros_Services_Clients_Interop_IO.sequenceOk([ Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetSome(kernel.inviteResult))(result), Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(kernel.inviteText))(""), refreshUsers(kernel) ]);
    };
};
var handleInvite = function (kernel) {
    return function (entries) {
        var $30 = Data_Array.length(entries) === 0;
        if ($30) {
            return runLoadingAction(kernel.loading.setError(toLoadingErrorInput("Add at least one valid email address.")));
        };
        return Ouroboros_Services_Clients_Interop_IO.sequenceOk([ Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetMaybe(kernel.inviteResult))(Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)), runTaskWithError(kernel)(kernel.adminUserClient.inviteUsers(entries))(Ouroboros_Services_Clients_Interop_Option.some(handleInviteSuccess(kernel))) ]);
    };
};
var onInvite = function (kernel) {
    return handleInvite(kernel);
};
var handleUserAction = function (kernel) {
    return function (toTask) {
        return function (user) {
            return runTaskWithError(kernel)(toTask(user))(Ouroboros_Services_Clients_Interop_Option.some(function (v) {
                return refreshUsers(kernel);
            }));
        };
    };
};
var onDeleteUser = function (kernel) {
    return handleUserAction(kernel)(function (user) {
        return kernel.adminUserClient.deleteUser(Ouroboros_Models_Brands_UUID.unwrap(user.id));
    });
};
var onReactivateUser = function (kernel) {
    return handleUserAction(kernel)(function (user) {
        return kernel.adminUserClient.reactivateUser(Ouroboros_Models_Brands_UUID.unwrap(user.id));
    });
};
var onRemovePending = function (kernel) {
    return handleUserAction(kernel)(function (user) {
        return kernel.adminUserClient.removePending(Ouroboros_Models_Brands_UUID.unwrap(user.id));
    });
};
var onResendInvite = function (kernel) {
    return handleUserAction(kernel)(function (user) {
        return kernel.adminUserClient.resendInvite(Ouroboros_Models_Brands_UUID.unwrap(user.id));
    });
};
var onSuspendUser = function (kernel) {
    return handleUserAction(kernel)(function (user) {
        return kernel.adminUserClient.suspendUser(Ouroboros_Models_Brands_UUID.unwrap(user.id));
    });
};
var onRefresh = function (kernel) {
    return function (v) {
        return refreshUsers(kernel);
    };
};
var documentationPath = "/documentation/drafting/frontend-program-builder/controllers/admin_users_controller.md";
var closeEmailModal = function (kernel) {
    return Ouroboros_Services_Clients_Interop_IO.sequenceOk([ Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetMaybe(kernel.emailModalUser))(Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)), Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(kernel.emailModalValue))(""), Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetMaybe(kernel.emailModalError))(Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)), Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(kernel.emailModalSubmitting))(false) ]);
};
var handleEmailModalSuccess = function (kernel) {
    return function (v) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Services_Clients_Interop_IO.sequenceOk([ runLoadingAction(kernel.loading.setSuccess), closeEmailModal(kernel), refreshUsers(kernel) ]));
    };
};
var emailModalTask = function (kernel) {
    return function (user) {
        return function (nextEmail) {
            var userId = Ouroboros_Models_Brands_UUID.unwrap(user.id);
            var changeTask = kernel.adminUserClient.changeEmail(userId)(nextEmail);
            var combinedTask = (function () {
                var $31 = Ouroboros_Models_Brands_AdminUserStatus.unwrap(user.status) === "Pending";
                if ($31) {
                    return Ouroboros_Services_Clients_Interop_TaskEither.chain(function (v) {
                        return kernel.adminUserClient.resendInvite(userId);
                    })(changeTask);
                };
                return changeTask;
            })();
            return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
                return Ouroboros_Services_Clients_Interop_TaskEither.fold(handleEmailModalError(kernel))(handleEmailModalSuccess(kernel))(combinedTask);
            })(Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Services_Clients_Interop_IO.sequenceOk([ Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(kernel.emailModalSubmitting))(true), Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetMaybe(kernel.emailModalError))(Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)), runLoadingAction(kernel.loading.setLoading) ])));
        };
    };
};
var handleEmailModalSubmit = function (kernel) {
    return function (maybeEmail) {
        var modalUser = readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(kernel.emailModalUser));
        return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return Ouroboros_Services_Clients_Interop_IO.pure(Ouroboros_Models_Core_Ok.ok);
        })(function (user) {
            return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
                return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetSome(kernel.emailModalError))("Enter a single valid email address.");
            })(function (email) {
                return Ouroboros_Programs_Capabilities.runTaskRunner(kernel.taskRunner)(emailModalTask(kernel)(user)(email));
            })(maybeEmail);
        })(modalUser);
    };
};
var onEmailModalSubmit = function (kernel) {
    return handleEmailModalSubmit(kernel);
};
var onCloseEmailModal = function (kernel) {
    return function (v) {
        return closeEmailModal(kernel);
    };
};
var buildOnInit = function (kernel) {
    var $32 = Data_Array.length(readState(Ouroboros_Programs_Capabilities.stateHandleRead(kernel.users))) === 0;
    if ($32) {
        return Ouroboros_Services_Clients_Interop_Option.some(Ouroboros_Programs_Capabilities.runTaskRunner(kernel.taskRunner)(mountTask(kernel)));
    };
    return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
};
var buildCurrentRole = function (users) {
    return function (currentEmail) {
        return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
        })(function (email) {
            var v = Data_Array.find(matchesEmail(email))(users);
            if (v instanceof Data_Maybe.Nothing) {
                return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
            };
            if (v instanceof Data_Maybe.Just) {
                return Ouroboros_Services_Clients_Interop_Option.some(v.value0.role);
            };
            throw new Error("Failed pattern match at Ouroboros.Programs.Controllers.AdminUsers (line 330, column 7 - line 332, column 43): " + [ v.constructor.name ]);
        })(currentEmail);
    };
};
var handleRoleChange = function (kernel) {
    return function (change) {
        var users = readState(Ouroboros_Programs_Capabilities.stateHandleRead(kernel.users));
        var currentEmail = readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(kernel.currentEmail));
        var currentRole = buildCurrentRole(users)(currentEmail);
        var isSuperAdmin = isSuperAdminFromRole(currentRole);
        var $35 = !isSuperAdmin || eq2(change.nextRole)(change.user.role);
        if ($35) {
            return Ouroboros_Services_Clients_Interop_IO.pure(Ouroboros_Models_Core_Ok.ok);
        };
        return runTaskWithError(kernel)(kernel.adminUserClient.changeRole(Ouroboros_Models_Brands_UUID.unwrap(change.user.id))(change.nextRole))(Ouroboros_Services_Clients_Interop_Option.some(function (v) {
            return refreshUsers(kernel);
        }));
    };
};
var onRoleChange = function (kernel) {
    return handleRoleChange(kernel);
};
export {
    buildOnInit,
    onInvite,
    onRefresh,
    onRoleChange,
    onResendInvite,
    onRemovePending,
    onSuspendUser,
    onReactivateUser,
    onDeleteUser,
    onOpenEmailModal,
    onCloseEmailModal,
    onEmailModalSubmit,
    documentationPath
};
//# sourceMappingURL=index.js.map
